// extracted by mini-css-extract-plugin
export default {"deleteSection":"DeleteFileStyle_deleteSection__teO2g","deleteSectionBtn":"DeleteFileStyle_deleteSectionBtn__A379O"};